/**
 * @description Lodash's startcase function.
 */
import startcase from 'lodash.startcase';

export const _startcase = startcase;

/**
 * @description Helper function for querying dom.
 */
// eslint-disable-next-line
export const domQueryAll = function(selector, parent, callback) {
	parent.querySelectorAll(selector).forEach(el => {
		callback(el);
	});
};

export const getDemoAsset = function(assetName) {
	return require(`@/assets/images/__demo/${assetName}`);
};

export const getImagesAsset = function(assetName) {
	return require(`@/assets/images/${assetName}`);
};

export const formatNumber = function(num) {
	if (num || num === 0) {
		return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	} else {
		return '';
	}
};

export const formatMixStrNum = function(num) {
	if (num) {
		if (isNaN(num)) {
			let newStr = '';
			const numArr = num.split(' ');
			for (let i = 0; i < numArr.length; i++) {
				if (!isNaN(numArr[i])) {
					newStr +=
						' ' +
						numArr[i].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
				} else {
					newStr += ' ' + numArr[i];
				}
			}
			return newStr;
		} else {
			return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		}
	} else {
		return '';
	}
};

export const formatPrice = function(event) {
	const _self = event.currentTarget;
	const currentValue = _self.value;
	const keysAllowed = [
		'0',
		'1',
		'2',
		'3',
		'4',
		'5',
		'6',
		'7',
		'8',
		'9',
		'.',
		'(',
		')',
		'+',
		' ',
		'-'
	];
	const keyPressed = event.key;

	if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
		event.preventDefault();
	}

	if (
		!(
			keysAllowed.includes(keyPressed) ||
			Boolean(keyPressed.match(/[a-zA-Z]/))
		) &&
		event.keyCode !== 8 &&
		event.keyCode !== 9 &&
		event.keyCode !== 39 &&
		event.keyCode !== 37 &&
		event.keyCode !== 46
	) {
		event.preventDefault();
	}

	if (currentValue < 0) {
		_self.value = 0;
	}
};

export const restrictSpecialCharacters = function(event) {
	const _self = event.currentTarget;
	const currentValue = _self.value;
	const keyPressed = event.key;

	if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
		event.preventDefault();
	}
	if (keyPressed) {
		if (
			Boolean(!keyPressed.match(/[a-zA-Z0-9-]/)) &&
			event.keyCode !== 8 &&
			event.keyCode !== 9 &&
			event.keyCode !== 39 &&
			event.keyCode !== 37 &&
			event.keyCode !== 32
		) {
			event.preventDefault();
		}

		if (currentValue < 0) {
			_self.value = 0;
		}
	}
};

export const formatPhone = function(event) {
	const _self = event.currentTarget;
	const currentValue = _self.value;
	const keysAllowed = [
		'0',
		'1',
		'2',
		'3',
		'4',
		'5',
		'6',
		'7',
		'8',
		'9',
		'.',
		'(',
		')',
		'+',
		' ',
		'-'
	];
	const keyPressed = event.key;

	if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
		event.preventDefault();
	}

	if (
		!keysAllowed.includes(keyPressed) &&
		event.keyCode !== 8 &&
		event.keyCode !== 9 &&
		event.keyCode !== 39 &&
		event.keyCode !== 37 &&
		event.keyCode !== 46
	) {
		event.preventDefault();
	}

	if (currentValue < 0) {
		_self.value = 0;
	}
};

export const formatDate = date => {
	if (date) {
		const dateReverse = new Date(date);
		const dd = dateReverse.getDate();
		const mm = dateReverse.getMonth() + 1;
		const yyyy = dateReverse.getFullYear();
		let str = '';

		mm < 10 ? (str += '0' + mm) : (str += mm);

		dd < 10 ? (str += '/0' + dd) : (str += '/' + dd);

		str += '/' + yyyy;
		return str;
	} else {
		return '';
	}
};

export const formatTimeZone = date => {
	if (date) {
		const dateReverse = new Date(date).toLocaleString('en-US', {
			timeZone: 'America/New_York'
		});
		const str = dateReverse.substring(dateReverse.indexOf(',') + 1);

		return str;
	} else {
		return '';
	}
};

export const formatTime = date => {
	if (date) {
		const dateReverse = new Date(date).toLocaleString('en-US');
		const str = dateReverse.substring(dateReverse.indexOf(',') + 1);

		return str;
	} else {
		return '';
	}
};

export const allowOnlyNumbersGlobal = function(evt) {
	const _self = evt.currentTarget;
	const currentValue = _self.value;
	const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
	const keyPressed = evt.key;

	if (evt.key === 'ArrowUp' || evt.key === 'ArrowDown') {
		evt.preventDefault();
	}

	if (
		!keysAllowed.includes(keyPressed) &&
		evt.keyCode !== 8 &&
		evt.keyCode !== 9 &&
		evt.keyCode !== 39 &&
		evt.keyCode !== 37 &&
		evt.keyCode !== 46
	) {
		evt.preventDefault();
	}

	if (currentValue < 0) {
		_self.value = 0;
	}
};

/**
 * @description Toggle slide animation.
 */
export const slideToggle = {
	config: {
		duration: 300,
		easing: 'ease-in'
	},

	slideUp: (target, configuration = {}) => {
		const config = { ...slideToggle.config, ...configuration };

		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = config.duration + 'ms';
		target.style.transitionTimingFunction = config.easing;
		target.style.boxSizing = 'border-box';
		target.style.height = target.offsetHeight + 'px';
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		window.setTimeout(() => {
			target.style.display = 'none';
			target.style.removeProperty('height');
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			target.style.removeProperty('transition-timing-function');
		}, config.duration);
	},

	slideDown: (target, configuration = {}) => {
		const config = { ...slideToggle.config, ...configuration };

		target.style.removeProperty('display');
		let display = window.getComputedStyle(target).display;

		if (display === 'none') {
			display = 'block';
		}

		target.style.display = display;
		const height = target.offsetHeight;
		target.style.overflow = 'hidden';
		target.style.height = 0;
		target.style.paddingTop = 0;
		target.style.paddingBottom = 0;
		target.style.marginTop = 0;
		target.style.marginBottom = 0;
		// eslint-disable-next-line no-unused-expressions
		target.offsetHeight;
		target.style.boxSizing = 'border-box';
		target.style.transitionProperty = 'height, margin, padding';
		target.style.transitionDuration = config.duration + 'ms';
		target.style.transitionTimingFunction = config.easing;
		target.style.height = height + 'px';
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		window.setTimeout(() => {
			target.style.removeProperty('height');
			target.style.removeProperty('overflow');
			target.style.removeProperty('transition-duration');
			target.style.removeProperty('transition-property');
			target.style.removeProperty('transition-timing-function');
		}, config.duration);
	},

	slideToggle: (target, configuration = {}) => {
		const config = { ...slideToggle.config, ...configuration };

		if (window.getComputedStyle(target).display === 'none') {
			return this.slideDown(target, config);
		} else {
			return this.slideUp(target, config);
		}
	}
};

export const toBase64 = file => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
	});
};
